export default __webpack_public_path__ + "static/media/infra-15.cc06c569.webp";